import { Button } from "@/components/ui/button";
import { GraduationCap, ShieldCheck, TrendingUp } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const bg =
    "https://images.unsplash.com/photo-1781513144825-aa1e284c5950?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwYWVzdGhldGljJTIwY2xpbmljJTIwaW50ZXJpb3IlMjBsdXh1cnl8ZW58MHx8fHwxNzg3NjQ4NTQ1fDA&ixlib=rb-4.1.0&q=85";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0B1120]">
      <div className="relative hidden lg:block">
        <img src={bg} alt="Clinic" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120] via-[#0B1120]/60 to-transparent" />
        <div className="relative z-10 h-full flex flex-col justify-end p-14">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-11 w-11 rounded-lg bg-[#C9A24B] flex items-center justify-center">
              <GraduationCap className="h-6 w-6 text-[#0B1120]" />
            </div>
            <div>
              <p className="text-[#C9A24B] font-display text-lg leading-tight">Youngness Centre</p>
              <p className="text-slate-400 text-xs tracking-widest uppercase">by Dr. Awish</p>
            </div>
          </div>
          <h1 className="text-4xl xl:text-5xl font-light font-display tracking-tighter text-white max-w-md">
            Training &amp; Development Command Centre
          </h1>
          <p className="text-slate-400 mt-4 max-w-sm">
            Every department SOP-ready, knowledge-ready and test-ready — with a documented path to improvement for every team member.
          </p>
          <div className="flex gap-6 mt-8 text-slate-300 text-sm">
            <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-[#059669]" /> SOP Compliance</span>
            <span className="flex items-center gap-2"><TrendingUp className="h-4 w-4 text-[#C9A24B]" /> Readiness Scoring</span>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-10">
            <div className="h-11 w-11 rounded-lg bg-[#C9A24B] flex items-center justify-center">
              <GraduationCap className="h-6 w-6 text-[#0B1120]" />
            </div>
            <p className="text-[#C9A24B] font-display text-lg">Youngness Centre</p>
          </div>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-slate-500 mb-3">Trainer Access</p>
          <h2 className="text-3xl font-semibold font-display tracking-tight text-white mb-2">Sign in</h2>
          <p className="text-slate-400 mb-8 text-sm">Use your Youngness Centre Google account to continue.</p>
          <Button
            data-testid="google-signin-button"
            onClick={handleLogin}
            className="w-full h-12 bg-white text-slate-900 hover:bg-slate-100 font-medium gap-3"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Continue with Google
          </Button>
          <p className="text-slate-600 text-xs mt-8">
            Restricted to authorized Youngness Centre personnel.
          </p>
        </div>
      </div>
    </div>
  );
}
